// @generated by protoc-gen-es v2.15.0 with parameter "target=ts,import_extension=js"
// @generated from file console/admin/v1/user.proto (package console.admin.v1, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { Timestamp } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { ConsoleRole, OperatorRole, Product, StaffRole, UserStatus } from "../../common/v1/common_pb.js";
import { file_console_common_v1_common } from "../../common/v1/common_pb.js";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file console/admin/v1/user.proto.
 */
export const file_console_admin_v1_user: GenFile = /*@__PURE__*/
  fileDesc("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", [file_google_protobuf_timestamp, file_console_common_v1_common]);

/**
 * @generated from message console.admin.v1.User
 */
export type User = Message<"console.admin.v1.User"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string org_id = 2;
   */
  orgId: string;

  /**
   * @generated from field: string email = 3;
   */
  email: string;

  /**
   * @generated from field: string display_name = 4;
   */
  displayName: string;

  /**
   * @generated from field: console.common.v1.ConsoleRole console_role = 5;
   */
  consoleRole: ConsoleRole;

  /**
   * @generated from field: console.common.v1.OperatorRole operator_role = 6;
   */
  operatorRole: OperatorRole;

  /**
   * @generated from field: console.common.v1.UserStatus status = 7;
   */
  status: UserStatus;

  /**
   * @generated from field: repeated console.common.v1.Product restricted_products = 8;
   */
  restrictedProducts: Product[];

  /**
   * Where the account came from: `invite`, `directory_sync`, `self_enroll`, `idp`
   * (added at the identity provider).
   *
   * @generated from field: string source = 9;
   */
  source: string;

  /**
   * @generated from field: bool mfa_enrolled = 10;
   */
  mfaEnrolled: boolean;

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 11;
   */
  createdAt?: Timestamp | undefined;

  /**
   * @generated from field: google.protobuf.Timestamp last_login_at = 12;
   */
  lastLoginAt?: Timestamp | undefined;

  /**
   * An administrator or member of staff who was made an operator as well.
   * Always false for someone whose role is operator.
   *
   * @generated from field: bool operator_access = 14;
   */
  operatorAccess: boolean;

  /**
   * For MS_STAFF, what they may change. Empty for everyone else, and for
   * read-only staff.
   *
   * @generated from field: repeated console.common.v1.StaffRole staff_roles = 15;
   */
  staffRoles: StaffRole[];

  /**
   * Where they stand with devices. The service decides it; the console
   * shows it.
   *
   * @generated from field: console.admin.v1.SeatState seat = 16;
   */
  seat: SeatState;
};

/**
 * Describes the message console.admin.v1.User.
 * Use `create(UserSchema)` to create a new message.
 */
export const UserSchema: GenMessage<User> = /*@__PURE__*/
  messageDesc(file_console_admin_v1_user, 0);

/**
 * @generated from message console.admin.v1.InviteUserRequest
 */
export type InviteUserRequest = Message<"console.admin.v1.InviteUserRequest"> & {
  /**
   * @generated from field: string org_id = 1;
   */
  orgId: string;

  /**
   * @generated from field: string email = 2;
   */
  email: string;

  /**
   * @generated from field: string display_name = 3;
   */
  displayName: string;

  /**
   * @generated from field: console.common.v1.ConsoleRole console_role = 4;
   */
  consoleRole: ConsoleRole;

  /**
   * @generated from field: console.common.v1.OperatorRole operator_role = 5;
   */
  operatorRole: OperatorRole;

  /**
   * With console_role MS_STAFF: the staff roles they start with.
   *
   * @generated from field: repeated console.common.v1.StaffRole staff_roles = 7;
   */
  staffRoles: StaffRole[];

  /**
   * An administrator or member of staff who signs in on devices as well,
   * taken in the same call. Where no seat is free they are invited without
   * it and `seat_limit_reached` says so.
   *
   * @generated from field: bool operator_access = 8;
   */
  operatorAccess: boolean;

  /**
   * Products they are kept off from the start, as SetRestrictedProducts.
   *
   * @generated from field: repeated console.common.v1.Product restricted_products = 9;
   */
  restrictedProducts: Product[];
};

/**
 * Describes the message console.admin.v1.InviteUserRequest.
 * Use `create(InviteUserRequestSchema)` to create a new message.
 */
export const InviteUserRequestSchema: GenMessage<InviteUserRequest> = /*@__PURE__*/
  messageDesc(file_console_admin_v1_user, 1);

/**
 * @generated from message console.admin.v1.InviteUserResponse
 */
export type InviteUserResponse = Message<"console.admin.v1.InviteUserResponse"> & {
  /**
   * @generated from field: console.admin.v1.User user = 1;
   */
  user?: User | undefined;

  /**
   * True when the account was created PENDING_SEAT because the pool is full.
   *
   * @generated from field: bool seat_limit_reached = 2;
   */
  seatLimitReached: boolean;

  /**
   * False when the identity provider refused to send the invitation email.
   * The account is made all the same; ResendInvitation tries again.
   *
   * @generated from field: bool invitation_sent = 3;
   */
  invitationSent: boolean;

  /**
   * The identity provider's own words for the refusal; empty when it was sent.
   *
   * @generated from field: string invitation_problem = 4;
   */
  invitationProblem: string;
};

/**
 * Describes the message console.admin.v1.InviteUserResponse.
 * Use `create(InviteUserResponseSchema)` to create a new message.
 */
export const InviteUserResponseSchema: GenMessage<InviteUserResponse> = /*@__PURE__*/
  messageDesc(file_console_admin_v1_user, 2);

/**
 * @generated from message console.admin.v1.GetUserRequest
 */
export type GetUserRequest = Message<"console.admin.v1.GetUserRequest"> & {
  /**
   * @generated from field: string user_id = 1;
   */
  userId: string;
};

/**
 * Describes the message console.admin.v1.GetUserRequest.
 * Use `create(GetUserRequestSchema)` to create a new message.
 */
export const GetUserRequestSchema: GenMessage<GetUserRequest> = /*@__PURE__*/
  messageDesc(file_console_admin_v1_user, 3);

/**
 * @generated from message console.admin.v1.GetUserResponse
 */
export type GetUserResponse = Message<"console.admin.v1.GetUserResponse"> & {
  /**
   * @generated from field: console.admin.v1.User user = 1;
   */
  user?: User | undefined;
};

/**
 * Describes the message console.admin.v1.GetUserResponse.
 * Use `create(GetUserResponseSchema)` to create a new message.
 */
export const GetUserResponseSchema: GenMessage<GetUserResponse> = /*@__PURE__*/
  messageDesc(file_console_admin_v1_user, 4);

/**
 * @generated from message console.admin.v1.ListUsersRequest
 */
export type ListUsersRequest = Message<"console.admin.v1.ListUsersRequest"> & {
  /**
   * @generated from field: string org_id = 1;
   */
  orgId: string;

  /**
   * @generated from field: console.common.v1.ConsoleRole console_role = 2;
   */
  consoleRole: ConsoleRole;

  /**
   * @generated from field: console.common.v1.UserStatus status = 3;
   */
  status: UserStatus;

  /**
   * @generated from field: string query = 4;
   */
  query: string;

  /**
   * @generated from field: uint32 page_size = 5;
   */
  pageSize: number;

  /**
   * @generated from field: string page_token = 6;
   */
  pageToken: string;

  /**
   * MotionSafe staff only: people of every organization, whatever
   * organization is named.
   *
   * @generated from field: bool all_organizations = 7;
   */
  allOrganizations: boolean;

  /**
   * Who to list, in the roster's order: those with a seat first, then those
   * waiting for one, then the rest, removed people last, by name within.
   * Paged by offset. Unspecified lists everyone, newest first.
   *
   * @generated from field: console.admin.v1.PeopleView view = 8;
   */
  view: PeopleView;

  /**
   * On MotionSafe's own organization: the staff who hold this.
   *
   * @generated from field: console.admin.v1.StaffFilter staff_filter = 9;
   */
  staffFilter: StaffFilter;

  /**
   * Rows to skip, for a numbered page. Used in place of `page_token`.
   *
   * @generated from field: uint32 offset = 10;
   */
  offset: number;
};

/**
 * Describes the message console.admin.v1.ListUsersRequest.
 * Use `create(ListUsersRequestSchema)` to create a new message.
 */
export const ListUsersRequestSchema: GenMessage<ListUsersRequest> = /*@__PURE__*/
  messageDesc(file_console_admin_v1_user, 5);

/**
 * @generated from message console.admin.v1.ListUsersResponse
 */
export type ListUsersResponse = Message<"console.admin.v1.ListUsersResponse"> & {
  /**
   * @generated from field: repeated console.admin.v1.User users = 1;
   */
  users: User[];

  /**
   * @generated from field: string next_page_token = 2;
   */
  nextPageToken: string;

  /**
   * How many people match, across every page.
   *
   * @generated from field: uint32 total = 3;
   */
  total: number;
};

/**
 * Describes the message console.admin.v1.ListUsersResponse.
 * Use `create(ListUsersResponseSchema)` to create a new message.
 */
export const ListUsersResponseSchema: GenMessage<ListUsersResponse> = /*@__PURE__*/
  messageDesc(file_console_admin_v1_user, 6);

/**
 * @generated from message console.admin.v1.CountUsersRequest
 */
export type CountUsersRequest = Message<"console.admin.v1.CountUsersRequest"> & {
  /**
   * @generated from field: string org_id = 1;
   */
  orgId: string;
};

/**
 * Describes the message console.admin.v1.CountUsersRequest.
 * Use `create(CountUsersRequestSchema)` to create a new message.
 */
export const CountUsersRequestSchema: GenMessage<CountUsersRequest> = /*@__PURE__*/
  messageDesc(file_console_admin_v1_user, 7);

/**
 * @generated from message console.admin.v1.CountUsersResponse
 */
export type CountUsersResponse = Message<"console.admin.v1.CountUsersResponse"> & {
  /**
   * Every combination that has a person, once.
   *
   * @generated from field: repeated console.admin.v1.UserCount groups = 1;
   */
  groups: UserCount[];
};

/**
 * Describes the message console.admin.v1.CountUsersResponse.
 * Use `create(CountUsersResponseSchema)` to create a new message.
 */
export const CountUsersResponseSchema: GenMessage<CountUsersResponse> = /*@__PURE__*/
  messageDesc(file_console_admin_v1_user, 8);

/**
 * @generated from message console.admin.v1.UserCount
 */
export type UserCount = Message<"console.admin.v1.UserCount"> & {
  /**
   * @generated from field: console.common.v1.UserStatus status = 1;
   */
  status: UserStatus;

  /**
   * @generated from field: console.common.v1.ConsoleRole console_role = 2;
   */
  consoleRole: ConsoleRole;

  /**
   * As User.operator_access.
   *
   * @generated from field: bool operator_access = 3;
   */
  operatorAccess: boolean;

  /**
   * @generated from field: bool mfa_enrolled = 4;
   */
  mfaEnrolled: boolean;

  /**
   * As User.staff_roles.
   *
   * @generated from field: repeated console.common.v1.StaffRole staff_roles = 5;
   */
  staffRoles: StaffRole[];

  /**
   * As User.seat.
   *
   * @generated from field: console.admin.v1.SeatState seat = 7;
   */
  seat: SeatState;

  /**
   * @generated from field: uint32 users = 6;
   */
  users: number;
};

/**
 * Describes the message console.admin.v1.UserCount.
 * Use `create(UserCountSchema)` to create a new message.
 */
export const UserCountSchema: GenMessage<UserCount> = /*@__PURE__*/
  messageDesc(file_console_admin_v1_user, 9);

/**
 * @generated from message console.admin.v1.SetConsoleRoleRequest
 */
export type SetConsoleRoleRequest = Message<"console.admin.v1.SetConsoleRoleRequest"> & {
  /**
   * @generated from field: string user_id = 1;
   */
  userId: string;

  /**
   * MS_SUPERADMIN or MS_STAFF.
   *
   * @generated from field: console.common.v1.ConsoleRole console_role = 2;
   */
  consoleRole: ConsoleRole;

  /**
   * With MS_STAFF: every staff role they hold from now on; empty is read only.
   *
   * @generated from field: repeated console.common.v1.StaffRole staff_roles = 3;
   */
  staffRoles: StaffRole[];
};

/**
 * Describes the message console.admin.v1.SetConsoleRoleRequest.
 * Use `create(SetConsoleRoleRequestSchema)` to create a new message.
 */
export const SetConsoleRoleRequestSchema: GenMessage<SetConsoleRoleRequest> = /*@__PURE__*/
  messageDesc(file_console_admin_v1_user, 10);

/**
 * @generated from message console.admin.v1.SetConsoleRoleResponse
 */
export type SetConsoleRoleResponse = Message<"console.admin.v1.SetConsoleRoleResponse"> & {
  /**
   * @generated from field: console.admin.v1.User user = 1;
   */
  user?: User | undefined;
};

/**
 * Describes the message console.admin.v1.SetConsoleRoleResponse.
 * Use `create(SetConsoleRoleResponseSchema)` to create a new message.
 */
export const SetConsoleRoleResponseSchema: GenMessage<SetConsoleRoleResponse> = /*@__PURE__*/
  messageDesc(file_console_admin_v1_user, 11);

/**
 * @generated from message console.admin.v1.SetConsoleAccessRequest
 */
export type SetConsoleAccessRequest = Message<"console.admin.v1.SetConsoleAccessRequest"> & {
  /**
   * @generated from field: string user_id = 1;
   */
  userId: string;

  /**
   * @generated from field: bool enabled = 2;
   */
  enabled: boolean;
};

/**
 * Describes the message console.admin.v1.SetConsoleAccessRequest.
 * Use `create(SetConsoleAccessRequestSchema)` to create a new message.
 */
export const SetConsoleAccessRequestSchema: GenMessage<SetConsoleAccessRequest> = /*@__PURE__*/
  messageDesc(file_console_admin_v1_user, 12);

/**
 * @generated from message console.admin.v1.SetConsoleAccessResponse
 */
export type SetConsoleAccessResponse = Message<"console.admin.v1.SetConsoleAccessResponse"> & {
  /**
   * @generated from field: console.admin.v1.User user = 1;
   */
  user?: User | undefined;
};

/**
 * Describes the message console.admin.v1.SetConsoleAccessResponse.
 * Use `create(SetConsoleAccessResponseSchema)` to create a new message.
 */
export const SetConsoleAccessResponseSchema: GenMessage<SetConsoleAccessResponse> = /*@__PURE__*/
  messageDesc(file_console_admin_v1_user, 13);

/**
 * @generated from message console.admin.v1.SetOperatorAccessRequest
 */
export type SetOperatorAccessRequest = Message<"console.admin.v1.SetOperatorAccessRequest"> & {
  /**
   * @generated from field: string user_id = 1;
   */
  userId: string;

  /**
   * @generated from field: bool enabled = 2;
   */
  enabled: boolean;
};

/**
 * Describes the message console.admin.v1.SetOperatorAccessRequest.
 * Use `create(SetOperatorAccessRequestSchema)` to create a new message.
 */
export const SetOperatorAccessRequestSchema: GenMessage<SetOperatorAccessRequest> = /*@__PURE__*/
  messageDesc(file_console_admin_v1_user, 14);

/**
 * @generated from message console.admin.v1.SetOperatorAccessResponse
 */
export type SetOperatorAccessResponse = Message<"console.admin.v1.SetOperatorAccessResponse"> & {
  /**
   * @generated from field: console.admin.v1.User user = 1;
   */
  user?: User | undefined;
};

/**
 * Describes the message console.admin.v1.SetOperatorAccessResponse.
 * Use `create(SetOperatorAccessResponseSchema)` to create a new message.
 */
export const SetOperatorAccessResponseSchema: GenMessage<SetOperatorAccessResponse> = /*@__PURE__*/
  messageDesc(file_console_admin_v1_user, 15);

/**
 * @generated from message console.admin.v1.SetOperatorRoleRequest
 */
export type SetOperatorRoleRequest = Message<"console.admin.v1.SetOperatorRoleRequest"> & {
  /**
   * @generated from field: string user_id = 1;
   */
  userId: string;

  /**
   * @generated from field: console.common.v1.OperatorRole operator_role = 2;
   */
  operatorRole: OperatorRole;
};

/**
 * Describes the message console.admin.v1.SetOperatorRoleRequest.
 * Use `create(SetOperatorRoleRequestSchema)` to create a new message.
 */
export const SetOperatorRoleRequestSchema: GenMessage<SetOperatorRoleRequest> = /*@__PURE__*/
  messageDesc(file_console_admin_v1_user, 16);

/**
 * @generated from message console.admin.v1.SetOperatorRoleResponse
 */
export type SetOperatorRoleResponse = Message<"console.admin.v1.SetOperatorRoleResponse"> & {
  /**
   * @generated from field: console.admin.v1.User user = 1;
   */
  user?: User | undefined;
};

/**
 * Describes the message console.admin.v1.SetOperatorRoleResponse.
 * Use `create(SetOperatorRoleResponseSchema)` to create a new message.
 */
export const SetOperatorRoleResponseSchema: GenMessage<SetOperatorRoleResponse> = /*@__PURE__*/
  messageDesc(file_console_admin_v1_user, 17);

/**
 * @generated from message console.admin.v1.SetRestrictedProductsRequest
 */
export type SetRestrictedProductsRequest = Message<"console.admin.v1.SetRestrictedProductsRequest"> & {
  /**
   * @generated from field: string user_id = 1;
   */
  userId: string;

  /**
   * @generated from field: repeated console.common.v1.Product restricted_products = 2;
   */
  restrictedProducts: Product[];
};

/**
 * Describes the message console.admin.v1.SetRestrictedProductsRequest.
 * Use `create(SetRestrictedProductsRequestSchema)` to create a new message.
 */
export const SetRestrictedProductsRequestSchema: GenMessage<SetRestrictedProductsRequest> = /*@__PURE__*/
  messageDesc(file_console_admin_v1_user, 18);

/**
 * @generated from message console.admin.v1.SetRestrictedProductsResponse
 */
export type SetRestrictedProductsResponse = Message<"console.admin.v1.SetRestrictedProductsResponse"> & {
  /**
   * @generated from field: console.admin.v1.User user = 1;
   */
  user?: User | undefined;
};

/**
 * Describes the message console.admin.v1.SetRestrictedProductsResponse.
 * Use `create(SetRestrictedProductsResponseSchema)` to create a new message.
 */
export const SetRestrictedProductsResponseSchema: GenMessage<SetRestrictedProductsResponse> = /*@__PURE__*/
  messageDesc(file_console_admin_v1_user, 19);

/**
 * @generated from message console.admin.v1.SuspendUserRequest
 */
export type SuspendUserRequest = Message<"console.admin.v1.SuspendUserRequest"> & {
  /**
   * @generated from field: string user_id = 1;
   */
  userId: string;

  /**
   * @generated from field: string note = 2;
   */
  note: string;
};

/**
 * Describes the message console.admin.v1.SuspendUserRequest.
 * Use `create(SuspendUserRequestSchema)` to create a new message.
 */
export const SuspendUserRequestSchema: GenMessage<SuspendUserRequest> = /*@__PURE__*/
  messageDesc(file_console_admin_v1_user, 20);

/**
 * @generated from message console.admin.v1.SuspendUserResponse
 */
export type SuspendUserResponse = Message<"console.admin.v1.SuspendUserResponse"> & {
  /**
   * @generated from field: console.admin.v1.User user = 1;
   */
  user?: User | undefined;
};

/**
 * Describes the message console.admin.v1.SuspendUserResponse.
 * Use `create(SuspendUserResponseSchema)` to create a new message.
 */
export const SuspendUserResponseSchema: GenMessage<SuspendUserResponse> = /*@__PURE__*/
  messageDesc(file_console_admin_v1_user, 21);

/**
 * @generated from message console.admin.v1.RevokeSeatRequest
 */
export type RevokeSeatRequest = Message<"console.admin.v1.RevokeSeatRequest"> & {
  /**
   * @generated from field: string user_id = 1;
   */
  userId: string;
};

/**
 * Describes the message console.admin.v1.RevokeSeatRequest.
 * Use `create(RevokeSeatRequestSchema)` to create a new message.
 */
export const RevokeSeatRequestSchema: GenMessage<RevokeSeatRequest> = /*@__PURE__*/
  messageDesc(file_console_admin_v1_user, 22);

/**
 * @generated from message console.admin.v1.RevokeSeatResponse
 */
export type RevokeSeatResponse = Message<"console.admin.v1.RevokeSeatResponse"> & {
  /**
   * @generated from field: console.admin.v1.User user = 1;
   */
  user?: User | undefined;
};

/**
 * Describes the message console.admin.v1.RevokeSeatResponse.
 * Use `create(RevokeSeatResponseSchema)` to create a new message.
 */
export const RevokeSeatResponseSchema: GenMessage<RevokeSeatResponse> = /*@__PURE__*/
  messageDesc(file_console_admin_v1_user, 23);

/**
 * @generated from message console.admin.v1.ReinstateUserRequest
 */
export type ReinstateUserRequest = Message<"console.admin.v1.ReinstateUserRequest"> & {
  /**
   * @generated from field: string user_id = 1;
   */
  userId: string;
};

/**
 * Describes the message console.admin.v1.ReinstateUserRequest.
 * Use `create(ReinstateUserRequestSchema)` to create a new message.
 */
export const ReinstateUserRequestSchema: GenMessage<ReinstateUserRequest> = /*@__PURE__*/
  messageDesc(file_console_admin_v1_user, 24);

/**
 * @generated from message console.admin.v1.ReinstateUserResponse
 */
export type ReinstateUserResponse = Message<"console.admin.v1.ReinstateUserResponse"> & {
  /**
   * @generated from field: console.admin.v1.User user = 1;
   */
  user?: User | undefined;

  /**
   * @generated from field: bool seat_limit_reached = 2;
   */
  seatLimitReached: boolean;
};

/**
 * Describes the message console.admin.v1.ReinstateUserResponse.
 * Use `create(ReinstateUserResponseSchema)` to create a new message.
 */
export const ReinstateUserResponseSchema: GenMessage<ReinstateUserResponse> = /*@__PURE__*/
  messageDesc(file_console_admin_v1_user, 25);

/**
 * @generated from message console.admin.v1.ResetMfaRequest
 */
export type ResetMfaRequest = Message<"console.admin.v1.ResetMfaRequest"> & {
  /**
   * @generated from field: string user_id = 1;
   */
  userId: string;
};

/**
 * Describes the message console.admin.v1.ResetMfaRequest.
 * Use `create(ResetMfaRequestSchema)` to create a new message.
 */
export const ResetMfaRequestSchema: GenMessage<ResetMfaRequest> = /*@__PURE__*/
  messageDesc(file_console_admin_v1_user, 26);

/**
 * @generated from message console.admin.v1.ResetMfaResponse
 */
export type ResetMfaResponse = Message<"console.admin.v1.ResetMfaResponse"> & {
  /**
   * @generated from field: console.admin.v1.User user = 1;
   */
  user?: User | undefined;
};

/**
 * Describes the message console.admin.v1.ResetMfaResponse.
 * Use `create(ResetMfaResponseSchema)` to create a new message.
 */
export const ResetMfaResponseSchema: GenMessage<ResetMfaResponse> = /*@__PURE__*/
  messageDesc(file_console_admin_v1_user, 27);

/**
 * @generated from message console.admin.v1.SetEmailRequest
 */
export type SetEmailRequest = Message<"console.admin.v1.SetEmailRequest"> & {
  /**
   * @generated from field: string user_id = 1;
   */
  userId: string;

  /**
   * @generated from field: string email = 2;
   */
  email: string;
};

/**
 * Describes the message console.admin.v1.SetEmailRequest.
 * Use `create(SetEmailRequestSchema)` to create a new message.
 */
export const SetEmailRequestSchema: GenMessage<SetEmailRequest> = /*@__PURE__*/
  messageDesc(file_console_admin_v1_user, 28);

/**
 * @generated from message console.admin.v1.SetEmailResponse
 */
export type SetEmailResponse = Message<"console.admin.v1.SetEmailResponse"> & {
  /**
   * @generated from field: console.admin.v1.User user = 1;
   */
  user?: User | undefined;
};

/**
 * Describes the message console.admin.v1.SetEmailResponse.
 * Use `create(SetEmailResponseSchema)` to create a new message.
 */
export const SetEmailResponseSchema: GenMessage<SetEmailResponse> = /*@__PURE__*/
  messageDesc(file_console_admin_v1_user, 29);

/**
 * @generated from message console.admin.v1.ResetPasswordRequest
 */
export type ResetPasswordRequest = Message<"console.admin.v1.ResetPasswordRequest"> & {
  /**
   * @generated from field: string user_id = 1;
   */
  userId: string;
};

/**
 * Describes the message console.admin.v1.ResetPasswordRequest.
 * Use `create(ResetPasswordRequestSchema)` to create a new message.
 */
export const ResetPasswordRequestSchema: GenMessage<ResetPasswordRequest> = /*@__PURE__*/
  messageDesc(file_console_admin_v1_user, 30);

/**
 * @generated from message console.admin.v1.ResetPasswordResponse
 */
export type ResetPasswordResponse = Message<"console.admin.v1.ResetPasswordResponse"> & {
  /**
   * @generated from field: console.admin.v1.User user = 1;
   */
  user?: User | undefined;
};

/**
 * Describes the message console.admin.v1.ResetPasswordResponse.
 * Use `create(ResetPasswordResponseSchema)` to create a new message.
 */
export const ResetPasswordResponseSchema: GenMessage<ResetPasswordResponse> = /*@__PURE__*/
  messageDesc(file_console_admin_v1_user, 31);

/**
 * @generated from message console.admin.v1.ResendInvitationRequest
 */
export type ResendInvitationRequest = Message<"console.admin.v1.ResendInvitationRequest"> & {
  /**
   * @generated from field: string user_id = 1;
   */
  userId: string;
};

/**
 * Describes the message console.admin.v1.ResendInvitationRequest.
 * Use `create(ResendInvitationRequestSchema)` to create a new message.
 */
export const ResendInvitationRequestSchema: GenMessage<ResendInvitationRequest> = /*@__PURE__*/
  messageDesc(file_console_admin_v1_user, 32);

/**
 * @generated from message console.admin.v1.ResendInvitationResponse
 */
export type ResendInvitationResponse = Message<"console.admin.v1.ResendInvitationResponse"> & {
  /**
   * @generated from field: console.admin.v1.User user = 1;
   */
  user?: User | undefined;
};

/**
 * Describes the message console.admin.v1.ResendInvitationResponse.
 * Use `create(ResendInvitationResponseSchema)` to create a new message.
 */
export const ResendInvitationResponseSchema: GenMessage<ResendInvitationResponse> = /*@__PURE__*/
  messageDesc(file_console_admin_v1_user, 33);

/**
 * @generated from message console.admin.v1.DeleteUserRequest
 */
export type DeleteUserRequest = Message<"console.admin.v1.DeleteUserRequest"> & {
  /**
   * @generated from field: string user_id = 1;
   */
  userId: string;
};

/**
 * Describes the message console.admin.v1.DeleteUserRequest.
 * Use `create(DeleteUserRequestSchema)` to create a new message.
 */
export const DeleteUserRequestSchema: GenMessage<DeleteUserRequest> = /*@__PURE__*/
  messageDesc(file_console_admin_v1_user, 34);

/**
 * @generated from message console.admin.v1.SyncIdentitiesRequest
 */
export type SyncIdentitiesRequest = Message<"console.admin.v1.SyncIdentitiesRequest"> & {
};

/**
 * Describes the message console.admin.v1.SyncIdentitiesRequest.
 * Use `create(SyncIdentitiesRequestSchema)` to create a new message.
 */
export const SyncIdentitiesRequestSchema: GenMessage<SyncIdentitiesRequest> = /*@__PURE__*/
  messageDesc(file_console_admin_v1_user, 35);

/**
 * @generated from message console.admin.v1.SyncIdentitiesResponse
 */
export type SyncIdentitiesResponse = Message<"console.admin.v1.SyncIdentitiesResponse"> & {
  /**
   * @generated from field: uint32 applied = 1;
   */
  applied: number;

  /**
   * Changes that asked nothing of the console.
   *
   * @generated from field: uint32 ignored = 2;
   */
  ignored: number;

  /**
   * Changes stepped over after failing three times.
   *
   * @generated from field: uint32 skipped = 3;
   */
  skipped: number;

  /**
   * The run stopped early and will pick up from the same place.
   *
   * @generated from field: bool stopped = 4;
   */
  stopped: boolean;
};

/**
 * Describes the message console.admin.v1.SyncIdentitiesResponse.
 * Use `create(SyncIdentitiesResponseSchema)` to create a new message.
 */
export const SyncIdentitiesResponseSchema: GenMessage<SyncIdentitiesResponse> = /*@__PURE__*/
  messageDesc(file_console_admin_v1_user, 36);

/**
 * @generated from message console.admin.v1.ReconcileIdentitiesRequest
 */
export type ReconcileIdentitiesRequest = Message<"console.admin.v1.ReconcileIdentitiesRequest"> & {
};

/**
 * Describes the message console.admin.v1.ReconcileIdentitiesRequest.
 * Use `create(ReconcileIdentitiesRequestSchema)` to create a new message.
 */
export const ReconcileIdentitiesRequestSchema: GenMessage<ReconcileIdentitiesRequest> = /*@__PURE__*/
  messageDesc(file_console_admin_v1_user, 37);

/**
 * @generated from message console.admin.v1.ReconcileIdentitiesResponse
 */
export type ReconcileIdentitiesResponse = Message<"console.admin.v1.ReconcileIdentitiesResponse"> & {
  /**
   * @generated from field: uint32 checked = 1;
   */
  checked: number;

  /**
   * @generated from field: uint32 removed = 2;
   */
  removed: number;

  /**
   * The provider could not say; left alone until the next check.
   *
   * @generated from field: uint32 unknown = 3;
   */
  unknown: number;

  /**
   * Absent and left in place, because too many were absent at once.
   *
   * @generated from field: uint32 held = 4;
   */
  held: number;
};

/**
 * Describes the message console.admin.v1.ReconcileIdentitiesResponse.
 * Use `create(ReconcileIdentitiesResponseSchema)` to create a new message.
 */
export const ReconcileIdentitiesResponseSchema: GenMessage<ReconcileIdentitiesResponse> = /*@__PURE__*/
  messageDesc(file_console_admin_v1_user, 38);

/**
 * @generated from message console.admin.v1.DeleteUserResponse
 */
export type DeleteUserResponse = Message<"console.admin.v1.DeleteUserResponse"> & {
  /**
   * True when the row was removed; false when the account was deprovisioned
   * and kept for the record.
   *
   * @generated from field: bool removed = 1;
   */
  removed: boolean;
};

/**
 * Describes the message console.admin.v1.DeleteUserResponse.
 * Use `create(DeleteUserResponseSchema)` to create a new message.
 */
export const DeleteUserResponseSchema: GenMessage<DeleteUserResponse> = /*@__PURE__*/
  messageDesc(file_console_admin_v1_user, 39);

/**
 * @generated from message console.admin.v1.Session
 */
export type Session = Message<"console.admin.v1.Session"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string user_id = 2;
   */
  userId: string;

  /**
   * @generated from field: string device_id = 3;
   */
  deviceId: string;

  /**
   * Factors used at login, e.g. ["pwd", "otp"] or ["sso"].
   *
   * @generated from field: repeated string amr = 4;
   */
  amr: string[];

  /**
   * @generated from field: google.protobuf.Timestamp issued_at = 5;
   */
  issuedAt?: Timestamp | undefined;

  /**
   * @generated from field: google.protobuf.Timestamp expires_at = 6;
   */
  expiresAt?: Timestamp | undefined;

  /**
   * @generated from field: google.protobuf.Timestamp last_refreshed_at = 7;
   */
  lastRefreshedAt?: Timestamp | undefined;

  /**
   * @generated from field: google.protobuf.Timestamp revoked_at = 8;
   */
  revokedAt?: Timestamp | undefined;

  /**
   * @generated from field: string revoke_reason = 9;
   */
  revokeReason: string;
};

/**
 * Describes the message console.admin.v1.Session.
 * Use `create(SessionSchema)` to create a new message.
 */
export const SessionSchema: GenMessage<Session> = /*@__PURE__*/
  messageDesc(file_console_admin_v1_user, 40);

/**
 * @generated from message console.admin.v1.ListSessionsRequest
 */
export type ListSessionsRequest = Message<"console.admin.v1.ListSessionsRequest"> & {
  /**
   * @generated from field: string user_id = 1;
   */
  userId: string;

  /**
   * @generated from field: bool include_ended = 2;
   */
  includeEnded: boolean;
};

/**
 * Describes the message console.admin.v1.ListSessionsRequest.
 * Use `create(ListSessionsRequestSchema)` to create a new message.
 */
export const ListSessionsRequestSchema: GenMessage<ListSessionsRequest> = /*@__PURE__*/
  messageDesc(file_console_admin_v1_user, 41);

/**
 * @generated from message console.admin.v1.ListSessionsResponse
 */
export type ListSessionsResponse = Message<"console.admin.v1.ListSessionsResponse"> & {
  /**
   * @generated from field: repeated console.admin.v1.Session sessions = 1;
   */
  sessions: Session[];
};

/**
 * Describes the message console.admin.v1.ListSessionsResponse.
 * Use `create(ListSessionsResponseSchema)` to create a new message.
 */
export const ListSessionsResponseSchema: GenMessage<ListSessionsResponse> = /*@__PURE__*/
  messageDesc(file_console_admin_v1_user, 42);

/**
 * @generated from message console.admin.v1.RevokeSessionsRequest
 */
export type RevokeSessionsRequest = Message<"console.admin.v1.RevokeSessionsRequest"> & {
  /**
   * @generated from field: string user_id = 1;
   */
  userId: string;

  /**
   * Empty revokes all of the user's sessions.
   *
   * @generated from field: string session_id = 2;
   */
  sessionId: string;

  /**
   * @generated from field: string note = 3;
   */
  note: string;
};

/**
 * Describes the message console.admin.v1.RevokeSessionsRequest.
 * Use `create(RevokeSessionsRequestSchema)` to create a new message.
 */
export const RevokeSessionsRequestSchema: GenMessage<RevokeSessionsRequest> = /*@__PURE__*/
  messageDesc(file_console_admin_v1_user, 43);

/**
 * @generated from message console.admin.v1.RevokeSessionsResponse
 */
export type RevokeSessionsResponse = Message<"console.admin.v1.RevokeSessionsResponse"> & {
  /**
   * @generated from field: uint32 revoked = 1;
   */
  revoked: number;
};

/**
 * Describes the message console.admin.v1.RevokeSessionsResponse.
 * Use `create(RevokeSessionsResponseSchema)` to create a new message.
 */
export const RevokeSessionsResponseSchema: GenMessage<RevokeSessionsResponse> = /*@__PURE__*/
  messageDesc(file_console_admin_v1_user, 44);

/**
 * @generated from message console.admin.v1.ListStaffRolesRequest
 */
export type ListStaffRolesRequest = Message<"console.admin.v1.ListStaffRolesRequest"> & {
};

/**
 * Describes the message console.admin.v1.ListStaffRolesRequest.
 * Use `create(ListStaffRolesRequestSchema)` to create a new message.
 */
export const ListStaffRolesRequestSchema: GenMessage<ListStaffRolesRequest> = /*@__PURE__*/
  messageDesc(file_console_admin_v1_user, 45);

/**
 * @generated from message console.admin.v1.StaffRoleInfo
 */
export type StaffRoleInfo = Message<"console.admin.v1.StaffRoleInfo"> & {
  /**
   * @generated from field: console.common.v1.StaffRole role = 1;
   */
  role: StaffRole;

  /**
   * The role's name as the console shows it: "Support".
   *
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * Who holds it, in a sentence.
   *
   * @generated from field: string summary = 3;
   */
  summary: string;
};

/**
 * Describes the message console.admin.v1.StaffRoleInfo.
 * Use `create(StaffRoleInfoSchema)` to create a new message.
 */
export const StaffRoleInfoSchema: GenMessage<StaffRoleInfo> = /*@__PURE__*/
  messageDesc(file_console_admin_v1_user, 46);

/**
 * One thing staff may change, and who may.
 *
 * @generated from message console.admin.v1.StaffCapability
 */
export type StaffCapability = Message<"console.admin.v1.StaffCapability"> & {
  /**
   * The part of the console it belongs to: "People", "Devices".
   *
   * @generated from field: string group = 1;
   */
  group: string;

  /**
   * @generated from field: string label = 2;
   */
  label: string;

  /**
   * A limit within it, when there is one: who it never applies to, or what
   * part of it stays with admins. Empty when there is none.
   *
   * @generated from field: string detail = 3;
   */
  detail: string;

  /**
   * The staff roles that allow it. Empty: MotionSafe admins only.
   *
   * @generated from field: repeated console.common.v1.StaffRole roles = 4;
   */
  roles: StaffRole[];

  /**
   * The admin RPC methods it covers, by name: "AssignDevice".
   *
   * @generated from field: repeated string methods = 5;
   */
  methods: string[];

  /**
   * An organization's administrators may do it too, for their own
   * organization. Not a staff role: the services decide it
   * (requireOrgAccess), and this says what they decide.
   *
   * @generated from field: bool org_admin = 6;
   */
  orgAdmin: boolean;
};

/**
 * Describes the message console.admin.v1.StaffCapability.
 * Use `create(StaffCapabilitySchema)` to create a new message.
 */
export const StaffCapabilitySchema: GenMessage<StaffCapability> = /*@__PURE__*/
  messageDesc(file_console_admin_v1_user, 47);

/**
 * @generated from message console.admin.v1.ListStaffRolesResponse
 */
export type ListStaffRolesResponse = Message<"console.admin.v1.ListStaffRolesResponse"> & {
  /**
   * @generated from field: repeated console.admin.v1.StaffRoleInfo roles = 1;
   */
  roles: StaffRoleInfo[];

  /**
   * Every change the admin API takes, each in exactly one capability.
   * Reading is not listed: every member of staff sees everything.
   *
   * @generated from field: repeated console.admin.v1.StaffCapability capabilities = 2;
   */
  capabilities: StaffCapability[];

  /**
   * Which admin RPC methods are reads, as a regular expression over the
   * method name: what every member of staff may call. A method that is
   * neither a read nor in a capability is an admin's.
   *
   * @generated from field: string read_methods = 3;
   */
  readMethods: string;
};

/**
 * Describes the message console.admin.v1.ListStaffRolesResponse.
 * Use `create(ListStaffRolesResponseSchema)` to create a new message.
 */
export const ListStaffRolesResponseSchema: GenMessage<ListStaffRolesResponse> = /*@__PURE__*/
  messageDesc(file_console_admin_v1_user, 48);

/**
 * Where a person stands with devices.
 *
 * @generated from enum console.admin.v1.SeatState
 */
export enum SeatState {
  /**
   * @generated from enum value: SEAT_STATE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * An operator who is active, or an active administrator or member of
   * staff who is an operator as well.
   *
   * @generated from enum value: SEAT_STATE_HOLDS = 1;
   */
  HOLDS = 1,

  /**
   * An operator who is not active yet (invited, waiting for a seat, or
   * suspended) and has not been removed.
   *
   * @generated from enum value: SEAT_STATE_WAITING = 2;
   */
  WAITING = 2,

  /**
   * Nothing to do with devices, or removed.
   *
   * @generated from enum value: SEAT_STATE_NONE = 3;
   */
  NONE = 3,
}

/**
 * Describes the enum console.admin.v1.SeatState.
 */
export const SeatStateSchema: GenEnum<SeatState> = /*@__PURE__*/
  enumDesc(file_console_admin_v1_user, 0);

/**
 * @generated from enum console.admin.v1.PeopleView
 */
export enum PeopleView {
  /**
   * @generated from enum value: PEOPLE_VIEW_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: PEOPLE_VIEW_EVERYONE = 1;
   */
  EVERYONE = 1,

  /**
   * Whoever holds or waits for a seat (User.seat).
   *
   * @generated from enum value: PEOPLE_VIEW_OPERATORS = 2;
   */
  OPERATORS = 2,

  /**
   * Whoever signs in to the console.
   *
   * @generated from enum value: PEOPLE_VIEW_ADMINISTRATORS = 3;
   */
  ADMINISTRATORS = 3,
}

/**
 * Describes the enum console.admin.v1.PeopleView.
 */
export const PeopleViewSchema: GenEnum<PeopleView> = /*@__PURE__*/
  enumDesc(file_console_admin_v1_user, 1);

/**
 * @generated from enum console.admin.v1.StaffFilter
 */
export enum StaffFilter {
  /**
   * @generated from enum value: STAFF_FILTER_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: STAFF_FILTER_ADMIN = 1;
   */
  ADMIN = 1,

  /**
   * @generated from enum value: STAFF_FILTER_SUPPORT = 2;
   */
  SUPPORT = 2,

  /**
   * @generated from enum value: STAFF_FILTER_FULFILLMENT = 3;
   */
  FULFILLMENT = 3,

  /**
   * @generated from enum value: STAFF_FILTER_ACCOUNTS = 4;
   */
  ACCOUNTS = 4,

  /**
   * Staff who hold no role.
   *
   * @generated from enum value: STAFF_FILTER_READ_ONLY = 5;
   */
  READ_ONLY = 5,
}

/**
 * Describes the enum console.admin.v1.StaffFilter.
 */
export const StaffFilterSchema: GenEnum<StaffFilter> = /*@__PURE__*/
  enumDesc(file_console_admin_v1_user, 2);

/**
 * People: operators and org admins. Operators consume a seat while ACTIVE.
 *
 * @generated from service console.admin.v1.UserService
 */
export const UserService: GenService<{
  /**
   * Sends an invitation through the identity vendor. If the organization's
   * seat pool is full the account is created PENDING_SEAT and the response
   * says so; it is never silently over the limit.
   *
   * @generated from rpc console.admin.v1.UserService.InviteUser
   */
  inviteUser: {
    methodKind: "unary";
    input: typeof InviteUserRequestSchema;
    output: typeof InviteUserResponseSchema;
  },
  /**
   * @generated from rpc console.admin.v1.UserService.GetUser
   */
  getUser: {
    methodKind: "unary";
    input: typeof GetUserRequestSchema;
    output: typeof GetUserResponseSchema;
  },
  /**
   * @generated from rpc console.admin.v1.UserService.ListUsers
   */
  listUsers: {
    methodKind: "unary";
    input: typeof ListUsersRequestSchema;
    output: typeof ListUsersResponseSchema;
  },
  /**
   * How many people there are, in groups a page sums as it needs, without
   * listing them.
   *
   * @generated from rpc console.admin.v1.UserService.CountUsers
   */
  countUsers: {
    methodKind: "unary";
    input: typeof CountUsersRequestSchema;
    output: typeof CountUsersResponseSchema;
  },
  /**
   * MotionSafe admins only. A member of staff made an admin, or staff with
   * the staff roles given; an admin's own role is changed by another admin.
   *
   * @generated from rpc console.admin.v1.UserService.SetConsoleRole
   */
  setConsoleRole: {
    methodKind: "unary";
    input: typeof SetConsoleRoleRequestSchema;
    output: typeof SetConsoleRoleResponseSchema;
  },
  /**
   * @generated from rpc console.admin.v1.UserService.SetOperatorRole
   */
  setOperatorRole: {
    methodKind: "unary";
    input: typeof SetOperatorRoleRequestSchema;
    output: typeof SetOperatorRoleResponseSchema;
  },
  /**
   * Give a person of an organization console access (they administer it), or
   * take it away, leaving whether they hold a seat as it is. Taking it from
   * someone with no seat is refused: they would have nothing left, and are
   * deleted instead. MotionSafe's own people change role with SetConsoleRole.
   *
   * @generated from rpc console.admin.v1.UserService.SetConsoleAccess
   */
  setConsoleAccess: {
    methodKind: "unary";
    input: typeof SetConsoleAccessRequestSchema;
    output: typeof SetConsoleAccessResponseSchema;
  },
  /**
   * Make an administrator, or a member of MotionSafe staff, an operator as
   * well, or stop. As an operator they sign in on devices; in an
   * organization with a seat pool they hold a seat, and turning it on is
   * refused when none is free. Never implied by a role: always set.
   *
   * @generated from rpc console.admin.v1.UserService.SetOperatorAccess
   */
  setOperatorAccess: {
    methodKind: "unary";
    input: typeof SetOperatorAccessRequestSchema;
    output: typeof SetOperatorAccessResponseSchema;
  },
  /**
   * Keep a person off a product the organization has. Cleared by passing an
   * empty list.
   *
   * @generated from rpc console.admin.v1.UserService.SetRestrictedProducts
   */
  setRestrictedProducts: {
    methodKind: "unary";
    input: typeof SetRestrictedProductsRequestSchema;
    output: typeof SetRestrictedProductsResponseSchema;
  },
  /**
   * Frees the seat and revokes every session.
   *
   * @generated from rpc console.admin.v1.UserService.SuspendUser
   */
  suspendUser: {
    methodKind: "unary";
    input: typeof SuspendUserRequestSchema;
    output: typeof SuspendUserResponseSchema;
  },
  /**
   * Takes a seat again; refused at the limit.
   *
   * @generated from rpc console.admin.v1.UserService.ReinstateUser
   */
  reinstateUser: {
    methodKind: "unary";
    input: typeof ReinstateUserRequestSchema;
    output: typeof ReinstateUserResponseSchema;
  },
  /**
   * Unassigns an operator's seat: they wait for one again, and their
   * sessions on devices end. The one way an operator is taken off devices
   * short of deleting them; `SuspendUser` is for administrators and staff.
   *
   * @generated from rpc console.admin.v1.UserService.RevokeSeat
   */
  revokeSeat: {
    methodKind: "unary";
    input: typeof RevokeSeatRequestSchema;
    output: typeof RevokeSeatResponseSchema;
  },
  /**
   * Removes the person's factors so they enroll again at next login.
   *
   * @generated from rpc console.admin.v1.UserService.ResetMfa
   */
  resetMfa: {
    methodKind: "unary";
    input: typeof ResetMfaRequestSchema;
    output: typeof ResetMfaResponseSchema;
  },
  /**
   * A new email address for someone who has signed in, set unverified: at
   * their next sign-in the identity provider emails a code to it, which the
   * console's sign-in page or the device asks for, so only the address's
   * owner gets in with it. It moves every account of the person, so an organization
   * administrator may change it only for someone who belongs to no other
   * organization; MotionSafe staff may for anyone. Refused for one's own
   * account (Change email in the account menu proves the new address
   * first), for an organization on its own single sign-on (its identity
   * provider owns the address), for someone who has never signed in
   * (invite the new address instead), and for an address another person
   * uses (ALREADY_EXISTS).
   *
   * @generated from rpc console.admin.v1.UserService.SetEmail
   */
  setEmail: {
    methodKind: "unary";
    input: typeof SetEmailRequestSchema;
    output: typeof SetEmailResponseSchema;
  },
  /**
   * Emails the person a link to choose a new password. The old one keeps
   * working until they do; every session ends when they do.
   *
   * @generated from rpc console.admin.v1.UserService.ResetPassword
   */
  resetPassword: {
    methodKind: "unary";
    input: typeof ResetPasswordRequestSchema;
    output: typeof ResetPasswordResponseSchema;
  },
  /**
   * Sends the invitation email again to an account that has not signed in
   * yet. A new link; earlier ones stop working.
   *
   * @generated from rpc console.admin.v1.UserService.ResendInvitation
   */
  resendInvitation: {
    methodKind: "unary";
    input: typeof ResendInvitationRequestSchema;
    output: typeof ResendInvitationResponseSchema;
  },
  /**
   * Removes a person. Someone who never signed in is removed entirely.
   * Someone who did is deprovisioned: they can no longer sign in, their seat
   * frees and their sessions end, and the row stays so the audit trail still
   * names who did the work.
   *
   * @generated from rpc console.admin.v1.UserService.DeleteUser
   */
  deleteUser: {
    methodKind: "unary";
    input: typeof DeleteUserRequestSchema;
    output: typeof DeleteUserResponseSchema;
  },
  /**
   * MotionSafe admins only. Checks every linked person against the identity
   * provider now, as the nightly check does, and removes whoever it no
   * longer has.
   *
   * @generated from rpc console.admin.v1.UserService.ReconcileIdentities
   */
  reconcileIdentities: {
    methodKind: "unary";
    input: typeof ReconcileIdentitiesRequestSchema;
    output: typeof ReconcileIdentitiesResponseSchema;
  },
  /**
   * MotionSafe admins only. Reads the identity provider's record of changes
   * from where the console last stopped and applies them now, as the run
   * every few minutes does.
   *
   * @generated from rpc console.admin.v1.UserService.SyncIdentities
   */
  syncIdentities: {
    methodKind: "unary";
    input: typeof SyncIdentitiesRequestSchema;
    output: typeof SyncIdentitiesResponseSchema;
  },
  /**
   * @generated from rpc console.admin.v1.UserService.ListSessions
   */
  listSessions: {
    methodKind: "unary";
    input: typeof ListSessionsRequestSchema;
    output: typeof ListSessionsResponseSchema;
  },
  /**
   * Revokes one session or all of a person's sessions. Reaches a tablet at
   * its next refresh; the console shows when that happened.
   *
   * @generated from rpc console.admin.v1.UserService.RevokeSessions
   */
  revokeSessions: {
    methodKind: "unary";
    input: typeof RevokeSessionsRequestSchema;
    output: typeof RevokeSessionsResponseSchema;
  },
  /**
   * MotionSafe staff. What each staff role may change, call by call: the
   * table the service refuses by, for the console to offer and explain.
   *
   * @generated from rpc console.admin.v1.UserService.ListStaffRoles
   */
  listStaffRoles: {
    methodKind: "unary";
    input: typeof ListStaffRolesRequestSchema;
    output: typeof ListStaffRolesResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_console_admin_v1_user, 0);

